import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Tooltip } from "react-tooltip";
import { Image } from "hesus-ui-kit";
import SolutionView from "../../../../Solution/SolutionView/SolutionView";
import AddEditDispute from "../../../../Dispute/AddEditDispute";
import AddEditSupplier from "../../../AddEditSupplier/AddEditSupplier";
import DisputeView from "../../../../Dispute/DisputeView";
import editIcon from "@icons/ic-edit-blue.svg";
import commentIcon from "@icons/ic-comment-blue.svg";
import disputeExistIcon from "@icons/dispute-exist.svg";
import noDisputeIcon from "@icons/no-dispute.svg";
import { handleApiError } from "@utils/errorHandler";

import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import {
  GridItem,
  OrderHeaderWrapper,
  SolutionIdLink,
  DivToolTip,
} from "./SupplierPlanning.styled";
import { GridRow, GridSubItem } from "../OrderSummary/OrderSummary.styled";
import "../../SupplierList.scss";

const SupplierPlanningList = (props) => {
  const {
    t,
    clientOrderId,
    planningLines,
    exchangeRates,
    quoteCurrency,
    isLoading,
    setRefreshState,
    jobsiteCountryId,
  } = props;

  const [openSupplierPlanningEditPopUp, setOpenSupplierPlanningEditPopUp] =
    useState(false);

  const [orderService, setOrderService] = useState({
    needCenter: false,
    needCarrier: false,
  });

  const [editId, setEditId] = useState("");

  const [currentSolution, setCurrentSolution] = useState(null);
  const [isSolutionViewPopupVisible, setSolutionViewPopupVisibility] =
    useState(false);
  const [isAddDisputePopupVisible, setAddDisputePopupVisible] = useState(false);
  const [isDisputeInPopUp, setDisputeInPopUp] = useState(false);
  const [isViewDisputePopupVisible, setViewDisputePopupVisible] =
    useState(false);
  const [addDisputeLineId, setAddDisputeLineId] = useState(false);
  const [addDisputeSiteId, setAddDisputeSiteId] = useState(false);
  const [disputeEdit, setDisputeEdit] = useState(false);
  const [disputeEditId, setDisputeEditId] = useState("");
  const [planningData, setPlanningData] = useState([]);

  const onSolutionIdClick = (solutionId) => {
    setSolutionViewPopupVisibility(false);
    axios
      .get(`/solutions/${solutionId}`)
      .then((response) => {
        setCurrentSolution(response.data[0]);
        setSolutionViewPopupVisibility(true);
      })
      .catch((error) => {
        handleApiError(error);
        setCurrentSolution();
        setSolutionViewPopupVisibility(false);
      });
  };

  const onSolutionViewClose = () => {
    setSolutionViewPopupVisibility(false);
  };

  const supplierPlanningEditAction = (id) => {
    setEditId(id);
    setOpenSupplierPlanningEditPopUp(true);
  };

  const closePlanningEditPopUp = () => {
    setEditId("");
    setOpenSupplierPlanningEditPopUp(false);
  };

  const onDisputeAdd = (lineId, siteId, data) => {
    setAddDisputeLineId(lineId);
    setAddDisputeSiteId(siteId);
    setPlanningData(data);
    setAddDisputePopupVisible(true);
    setDisputeEditId("");
    setDisputeEdit(false);
    setDisputeInPopUp(false);
  };

  const onDisputeAddInPopUp = (lineId, siteId) => {
    setAddDisputeLineId(lineId);
    setAddDisputeSiteId(siteId);
    setViewDisputePopupVisible(false);
    setAddDisputePopupVisible(true);
    setDisputeEditId("");
    setDisputeEdit(false);
    setDisputeInPopUp(true);
  };

  const onDisputeEdit = (disputeId) => {
    setDisputeEditId(disputeId);
    setDisputeEdit(true);
    setViewDisputePopupVisible(false);
    setAddDisputePopupVisible(true);
    setDisputeInPopUp(true);
  };

  const closeDisputeCreationPopup = () => {
    if (!isDisputeInPopUp) {
      setAddDisputeLineId("");
      setAddDisputeSiteId("");
      setDisputeEditId("");
    }
    if (isDisputeInPopUp) {
      setViewDisputePopupVisible(true);
    }
    setDisputeEdit(false);
    setAddDisputePopupVisible(false);
  };

  const updateDisputeRefeshStatus = () => {
    setRefreshState(true);
  };

  const onDisputeView = (lineId, siteId, data) => {
    setAddDisputeLineId(lineId);
    setAddDisputeSiteId(siteId);
    setPlanningData(data);
    setViewDisputePopupVisible(true);
  };

  const closeDisputeViewPopup = () => {
    setViewDisputePopupVisible(false);
    setPlanningData([]);
  };

  useEffect(() => {
    let tempService = orderService;
    planningLines?.[0]?.supplierPlanningLine?.map((line) => {
      if (line.hesusService.needCenter)
        tempService = { ...tempService, needCenter: true };

      if (line.hesusService.needCarrier)
        tempService = { ...tempService, needCarrier: true };
    });
    setOrderService(tempService);
  }, [planningLines]);

  return (
    <>
      {planningLines?.length === 0 && (
        <GridRow>
          <GridSubItem textAlign="center">
            {t("CLIENT_ORDER_NO_PLANNING_LINES")}
          </GridSubItem>
        </GridRow>
      )}

      {planningLines?.length > 0 && (
        <>
          <OrderHeaderWrapper>
            <GridRow
              column={
                orderService.needCenter && orderService.needCarrier
                  ? "38.8% 38.6% 7.7% 8.4% auto"
                  : "77.4% 7.7% 8.4% auto"
              }
              marginBottom="0px"
              gridGap="0rem"
              gap="0rem"
              marginTop="10px"
            >
              {orderService.needCenter && (
                <GridItem
                  textAlign="left"
                  fontWeight="700"
                  radius="5px 0px 0px 0px"
                  borderRight="1px solid #fff"
                >
                  {t("SUPPLIERS_PLANNING_SOLUTION")}
                </GridItem>
              )}
              {orderService.needCarrier && (
                <GridItem
                  textAlign="left"
                  fontWeight="700"
                  borderRight="1px solid #fff"
                >
                  {t("SUPPLIERS_PLANNING_HAULIER")}
                </GridItem>
              )}
              <GridItem fontWeight="700" borderRight="1px solid #fff">
                {t("SUPPLIERS_PLANNING_PLANNED")}
              </GridItem>
              <GridItem fontWeight="700" borderRight="1px solid #fff">
                {t("SUPPLIERS_PLANNING_MARGIN")}
              </GridItem>
              <GridItem
                fontWeight="700"
                radius="0px 5px 0px 0px"
                borderRight="0px solid #767676"
              >
                {t("SUPPLIERS_PLANNING_ACTIONS")}
              </GridItem>
            </GridRow>
          </OrderHeaderWrapper>

          {planningLines?.map((line, lineIndex) => {
            if (line?.supplierPlanningLine) {
              const len = Object.keys(line?.supplierPlanningLine).length - 1;
              return (
                <React.Fragment
                  key={"supplier-planning-line-group" + line?.lineGroupId}
                >
                  <GridRow
                    gap="0rem"
                    column="93.5% auto"
                    borderBottom="2px solid #767676"
                    key={`service-item-${line?.lineGroupId}${lineIndex}`}
                  >
                    <GridRow gap="0rem">
                      {line?.supplierPlanningLine.map((item, itemIndex) => {
                        return (
                          <GridRow
                            key={
                              "supplierPlanningList-" + itemIndex + "-" + item
                            }
                            column={
                              orderService.needCarrier &&
                              orderService.needCenter
                                ? "41.6% 41.3% 8.2% auto"
                                : "82.9% 8.2% auto"
                            }
                            marginBottom="0px"
                            gap="0rem"
                            marginTop="0px"
                            borderBottom={
                              itemIndex === len ? "none" : "1px solid #CCCCCC"
                            }
                          >
                            {orderService.needCenter && (
                              <GridRow
                                column="75% auto"
                                borderLeft="2px solid #767676"
                                borderRight="2px solid #767676"
                              >
                                {item.hesusService.needCenter &&
                                  (!item.hesusService.needCombination ||
                                    (item.hesusService.needCombination &&
                                      item.hesusService
                                        .needCombinationCarrier)) && (
                                    <>
                                      <GridRow gap="0rem">
                                        <GridSubItem
                                          fontWeight="700"
                                          fontSize="16px"
                                          padding="5px 5px 0px 10px"
                                        >
                                          <SolutionIdLink
                                            onClick={() =>
                                              onSolutionIdClick(
                                                item.solution.solutionId
                                              )
                                            }
                                          >
                                            #{item.solution.solutionId}
                                          </SolutionIdLink>{" "}
                                          - [{" "}
                                          {item?.solution?.centre?.supplierName}
                                          ] - {item.solution.centre?.name}
                                        </GridSubItem>
                                        <GridSubItem
                                          fontWeight="400"
                                          fontSize="16px"
                                          color="#474747"
                                          fontStyle="italic"
                                          padding="0px 5px 5px 10px"
                                        >
                                          {item.solution.product?.name}
                                        </GridSubItem>
                                      </GridRow>
                                      <GridSubItem
                                        fontWeight="700"
                                        fontSize="16px"
                                        textAlign="right"
                                        color="#474747"
                                      >
                                        {renderPriceWithCurrency(
                                          addSpace(
                                            getConvertedPrice(
                                              item?.solution?.currency?.id,
                                              item?.solution?.purchasePrice,
                                              exchangeRates
                                            )
                                          ),
                                          t(item?.solution?.purchaseUnit),
                                          quoteCurrency?.symbol,
                                          quoteCurrency?.position
                                        )}
                                      </GridSubItem>
                                    </>
                                  )}
                              </GridRow>
                            )}

                            {orderService.needCarrier && (
                              <GridRow
                                column="70% 5% auto"
                                borderRight="2px solid #767676"
                                borderLeft={
                                  !orderService.needCenter
                                    ? "2px solid #767676"
                                    : "none"
                                }
                                gap="0rem"
                              >
                                {item.hesusService.needCarrier &&
                                  (!item.hesusService.needCombination ||
                                    (item.hesusService.needCombination &&
                                      item.hesusService
                                        .needCombinationCenter)) && (
                                    <>
                                      <GridRow gap="0rem">
                                        <GridSubItem
                                          fontWeight="700"
                                          fontSize="16px"
                                          padding="5px 5px 0px 10px"
                                        >
                                          {item.haulage.company?.name}
                                        </GridSubItem>
                                        <GridSubItem
                                          fontWeight="400"
                                          fontSize="16px"
                                          color="#474747"
                                          fontStyle="italic"
                                          padding="0px 5px 5px 10px"
                                        >
                                          {item.haulage.transport?.name}
                                        </GridSubItem>
                                      </GridRow>
                                      <GridSubItem
                                        fontWeight="700"
                                        fontSize="16px"
                                        textAlign="right"
                                        color="#474747"
                                      >
                                        {item.haulage.comment && (
                                          <>
                                            <span
                                              id={`supplier-item-description-id${item.id}`}
                                            >
                                              <Image
                                                src={commentIcon}
                                                alt="comment"
                                                className="supplier-list__supplier-image-icon"
                                              />
                                            </span>
                                            <Tooltip
                                              anchorSelect={`#supplier-item-description-id${item.id}`}
                                              style={DivToolTip}
                                              border="1px solid #0A4986"
                                            >
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: item?.haulage.comment,
                                                }}
                                              />
                                            </Tooltip>
                                          </>
                                        )}
                                      </GridSubItem>
                                      <GridSubItem
                                        fontWeight="700"
                                        fontSize="16px"
                                        textAlign="right"
                                        color="#474747"
                                      >
                                        {renderPriceWithCurrency(
                                          addSpace(
                                            getConvertedPrice(
                                              item?.haulage?.currency?.id,
                                              item?.haulage?.purchasePrice,
                                              exchangeRates
                                            )
                                          ),
                                          t(item?.haulage?.purchaseUnit),
                                          quoteCurrency?.symbol,
                                          quoteCurrency?.position
                                        )}
                                      </GridSubItem>
                                    </>
                                  )}
                              </GridRow>
                            )}

                            <GridItem>
                              <GridSubItem
                                fontWeight="400"
                                fontSize="16px"
                                textAlign="center"
                                color="#0A4986"
                              >
                                {`${item.quantity} ${t(item.unit)}`}
                              </GridSubItem>
                            </GridItem>

                            <GridItem>
                              <GridSubItem
                                fontWeight="700"
                                fontSize="16px"
                                textAlign="center"
                                color={
                                  // eslint-disable-next-line no-nested-ternary
                                  item.marginRate >= 12
                                    ? "#0A4986"
                                    : item.marginRate <= 6
                                    ? "#E83F1E"
                                    : "#F08046"
                                }
                              >
                                {parseFloat(item.marginRate).toFixed(2)}%
                              </GridSubItem>
                            </GridItem>
                          </GridRow>
                        );
                      })}
                    </GridRow>
                    <GridRow gridGap="0rem">
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        textAlign="center"
                        borderRight="2px solid rgb(118, 118, 118)"
                      >
                        <Image
                          src={editIcon}
                          className="supplier-list__supplier-image-icon"
                          onClick={() =>
                            supplierPlanningEditAction([line?.lineGroupId])
                          }
                          alt={t("CLIENT_ORDER_EDIT_TOOLTIP")}
                          title={t("CLIENT_ORDER_EDIT_TOOLTIP")}
                        />

                        {parseInt(
                          line?.supplierPlanningLine?.[0]?.disputeCount,
                          10
                        ) > 0 && (
                          <Image
                            src={disputeExistIcon}
                            className="supplier-list__supplier-planning-list-icon"
                            onClick={() =>
                              onDisputeView(
                                line?.lineGroupId,
                                line?.supplierPlanningLine?.[0]?.site?.id,
                                line?.supplierPlanningLine
                              )
                            }
                            alt={t("SUPPLIERS_PLANNING_VIEW_DISPUTES")}
                            title={t("SUPPLIERS_PLANNING_VIEW_DISPUTES")}
                          />
                        )}
                        {parseInt(
                          line?.supplierPlanningLine?.[0]?.disputeCount,
                          10
                        ) === 0 && (
                          <Image
                            src={noDisputeIcon}
                            className="supplier-list__supplier-planning-list-icon"
                            onClick={() =>
                              onDisputeAdd(
                                line?.lineGroupId,
                                line?.supplierPlanningLine?.[0]?.site?.id,
                                line?.supplierPlanningLine
                              )
                            }
                            alt={t("SUPPLIERS_PLANNING_ADD_DISPUTE")}
                            title={t("SUPPLIERS_PLANNING_ADD_DISPUTE")}
                          />
                        )}
                      </GridSubItem>
                    </GridRow>
                  </GridRow>
                </React.Fragment>
              );
            }
          })}
          {openSupplierPlanningEditPopUp && (
            <AddEditSupplier
              onClose={closePlanningEditPopUp}
              clientOrderId={clientOrderId}
              setRefreshState={setRefreshState}
              isEdit
              lineGroupId={editId}
              countryId={jobsiteCountryId}
            />
          )}
          {isSolutionViewPopupVisible && (
            <SolutionView
              onClose={onSolutionViewClose}
              id={currentSolution.id}
              solutionData={currentSolution}
              isEditBtnVisible={false}
            />
          )}
          {isAddDisputePopupVisible && (
            <AddEditDispute
              id={disputeEditId}
              isEditMode={disputeEdit}
              siteId={addDisputeSiteId}
              planningId={addDisputeLineId}
              onClose={closeDisputeCreationPopup}
              updateDisputeRefeshStatus={updateDisputeRefeshStatus}
              planningData={planningData}
            />
          )}
          {isViewDisputePopupVisible && (
            <DisputeView
              planningId={addDisputeLineId}
              siteId={addDisputeSiteId}
              onClose={closeDisputeViewPopup}
              updateDisputeRefeshStatus={updateDisputeRefeshStatus}
              onDisputeAdd={onDisputeAddInPopUp}
              onDisputeEdit={onDisputeEdit}
            />
          )}
        </>
      )}
    </>
  );
};
SupplierPlanningList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SupplierPlanningList);
